import React, { useState, useEffect } from 'react';


export default ({
  handleClose = () => { },
  ESignURL = "",
}) => {
  return (
    <div id='task-modal-content'>
      <div className="task-head_container">
        <a className="event-head H6DesktopBlack" onClick={handleClose}>X</a>
      </div>
      <div>
        <iframe src={ESignURL} title="agreement-url" style={{ width: "100%", height: "750px" }} />
      </div>
    </div>
  )
}